<app-dropdown [(isOpen)]="isDropdownOpen" position="bottom-left">
  <!-- Trigger: Current Company Display -->
  <div slot="trigger"
    class="company-switcher-trigger flex items-center gap-3 px-4 py-2 bg-theme-bg-card border border-light rounded-[15px] hover:border-theme-primary-main transition-colors cursor-pointer">
    @if (currentCompany(); as company) {
    <!-- Company Logo/Icon -->
    <div class="flex items-center justify-center w-10 h-10">
      @if (hasLogo(company)) {
      <img [src]="getCompanyLogo(company)" [alt]="company.displayName" class="w-full h-full object-contain" />
      } @else if (hasIcon(company)) {
      <i [class]="company.icon + ' text-2xl text-theme-text-primary'"></i>
      } @else if (getFallbackImage(company.name)) {
      <img [src]="getFallbackImage(company.name)" [alt]="company.displayName" class="w-full h-full object-contain" />
      } @else {
      <i class="icofont icofont-building text-2xl text-theme-text-secondary"></i>
      }
    </div>

    <!-- Company Name - Hidden on mobile -->
    <span class="company-name text-theme-text-primary font-medium">
      {{ company.displayName }}
    </span>

    <!-- Dropdown Arrow - Hidden on mobile -->
    <img src="assets/headers-image/up-down.svg" alt="Toggle Company" class="dropdown-arrow w-6 h-6 object-contain" />
    }
  </div>

  <!-- Dropdown Content: Company List -->
  <div slot="content" class="py-1">
    @if (otherCompanies().length > 0) {
    @for (company of otherCompanies(); track company.name) {
    <div (click)="onCompanyClick(company)"
      class="flex items-center gap-3 px-4 py-3 hover:bg-theme-bg-hover cursor-pointer transition-colors">
      <!-- Company Logo/Icon -->
      <div class="flex items-center justify-center w-8 h-8">
        @if (hasLogo(company)) {
        <img [src]="getCompanyLogo(company)" [alt]="company.displayName" class="w-full h-full object-contain" />
        } @else if (hasIcon(company)) {
        <i [class]="company.icon + ' text-xl text-theme-text-primary'"></i>
        } @else if (getFallbackImage(company.name)) {
        <img [src]="getFallbackImage(company.name)" [alt]="company.displayName" class="w-full h-full object-contain" />
        } @else {
        <i class="icofont icofont-building text-xl text-theme-text-secondary"></i>
        }
      </div>

      <!-- Company Name -->
      <div class="flex flex-col">
        <span class="text-theme-text-primary font-medium">
          {{ company.displayName }}
        </span>
        <span class="text-xs text-theme-text-secondary">
          {{ company.name }}
        </span>
      </div>
    </div>
    }
    } @else {
    <div class="px-4 py-3 text-theme-text-secondary text-sm">
      No other companies available
    </div>
    }

    <!-- Current Company (shown at bottom with checkmark) -->
    @if (currentCompany(); as company) {
    <div class="border-t border-light mt-1 pt-1">
      <div class="flex items-center gap-3 px-4 py-3 bg-theme-bg-active">
        <!-- Company Logo/Icon -->
        <div class="flex items-center justify-center w-8 h-8">
          @if (hasLogo(company)) {
          <img [src]="getCompanyLogo(company)" [alt]="company.displayName" class="w-full h-full object-contain" />
          } @else if (hasIcon(company)) {
          <i [class]="company.icon + ' text-xl text-theme-primary-main'"></i>
          } @else if (getFallbackImage(company.name)) {
          <img [src]="getFallbackImage(company.name)" [alt]="company.displayName"
            class="w-full h-full object-contain" />
          } @else {
          <i class="icofont icofont-building text-xl text-theme-primary-main"></i>
          }
        </div>

        <!-- Company Name -->
        <div class="flex flex-col flex-1">
          <span class="text-theme-primary-main font-medium">
            {{ company.displayName }}
          </span>
          <span class="text-xs text-theme-text-secondary">
            Current
          </span>
        </div>

        <!-- Checkmark -->
        <i class="icofont icofont-check text-theme-primary-main text-lg"></i>
      </div>
    </div>
    }
  </div>
</app-dropdown>